import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import FormLabel from 'react-bootstrap/esm/FormLabel';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import API_BASE_URL, { api } from '../config/api';
import { checkCandidateDuplicate } from '../services/candidateService';
import { getDecryptedData } from '../utils/authStorage';
import { toDateInputValue, toIsoDateString, normalizeLwdForInput } from '../utils/dateFormat';
import { validateCandidateUploadForm } from '../utils/candidateUploadValidation';
import { getApiErrorMessage } from '../utils/apiError';
import { showSuccess, showError, showWarning } from '../utils/toast';
import { canUploadToRequirement, getUploadDisabledMessage } from '../utils/requirementWorkflow';
import StatusBadge from './ui/StatusBadge';
import { getPersistedCandidateStatus } from '../utils/candidateStatus';
import RequirementJdActions from './requirements/RequirementJdActions';
import PriorityBadge from './ui/PriorityBadge';
import { normalizeRequirementType } from '../utils/requirementType';



function UserActions({ embedded = false, onClose, onSuccess, modalPayload, onSubmitReadyChange }) {
   let updatedResumeRef = useRef();
   let ornnovaProfileRef = useRef();
   let candidateimageRef = useRef();
    const [show, setShow] = useState(false);
  const [allFieldsFilled, setAllFieldsFilled] = useState(false); // Check if all fields are filled

    const [loginUserData, setLoginUserData] = useState([]);
    const [uploadAllowed, setUploadAllowed] = useState(true);
    const [uploadBlockMessage, setUploadBlockMessage] = useState('');
    const { id: routeId } = useParams();
    const id = embedded && modalPayload?.reqId ? modalPayload.reqId : routeId;
    const [firstName,setFirstName]=useState();
    const [lastName,setLastName]=useState();
    const [email,setEmail]=useState();
    const [mobileNumber,setMobileNumber]=useState();
    const [dob,setDob]=useState('');
    const [ctc,setCtc]=useState();
    const [ectc,setEctc]=useState();  
    const [totalYoe,setTotalYoe]=useState();
    const [relevantYoe,setRelevantYoe]=useState();
    const [lwd,setLwd]=useState();
    const [currentLocation,setCurrentLocation]=useState();
    const [prefLocation,setPrefLocation]=useState();
    const [resignationServed,setResignationServed]=useState();
    const [currentOrg,setCurrentOrg]=useState();
    const [candidateSkills,setCandidateSkills]=useState();
    const [role,setRole]=useState();
    const [feedback,setFeedback]=useState();
    const [details,setDetails]=useState();
    const [interviewDate,setInterviewDate]=useState();
    const [educationalQualification,setEducationalQualification]=useState();
    const [offerInHand,setOfferInHand]=useState();
    const [remark,setRemark]=useState();
    const [, setSavedStatus] = useState();
    const [hover, setHover] = useState(false);
    const [isAssessmentSubmitted, setIsAssessmentSubmitted] = useState(false); // Tracks submission status
    const [scores, setScores] = useState([]);
    const [updateshow, setUpdateshow] = useState(false);
    const [candidateData,setCandidateData]= useState([]);
    const [EmployeeName,setEmployeeName]=useState("")
    const [updateCandidateDetails, setUpdateCandidateDetails] = useState({
      candidateImage: '',
      firstName: '',
      lastName: '',
      email: '',
      mobileNumber: '',
      dob: '',
      ctc: '',
      ectc: '',
      totalYoe: '',
      relevantYoe: '',
      lwd: '',
      currentLocation: '',
      prefLocation: '',
      resignationServed: '',
      currentOrg: '',
      candidateSkills: '',
      role: '',
      internalScreening: '',
      sharedWithClient: '',
      feedback: '',
      details: '',
      interviewDate: '',
      educationalQualification: '',
      offerInHand: '',
      remark: '',
      updatedResume: '',
      ornnovaProfile: '',
      assessments: [],
    });

    // const [updatedResume,setUpdatedResume]=useState();
    // const [ornnovaProfile,setOrnnovaProfile]=useState();
    // const [candidateImage,setCandidateImage]=useState();


    const userId = getDecryptedData('Id');
    const userEmail = getDecryptedData('Email');
    const [requirValues, setRequirValues] = useState({
        id: id,
        regId: "",
        client: "",
        typeOfContract: "",
        startDate: "",
        duration: "",
        location: "",
        sourceCtc: "",
        qualification: "",
        yearsExperience: "",
        relevantExperience: "",
        skill: "",
        assessments: [],
        update: "",
        claimedBy: [],
    });
    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
   
     
    const todayDate = getTodayDate();

    const viewCandidates = async()=>{
      try {
        const response = await api.get(`/viewactions/${id}/${userId}`)
        setCandidateData(response.data.candidates);
        // handleShow()
        // console.log(response.data);
      } catch (error) {
        // alert("No Candidates")
      }
    }

    useEffect(()=>{
      viewCandidates();
      
    })

    useEffect(() => {
        const fetchRequirement = async () => {
            try {
                const response = await api.get(`/actions/${id}/${userId}`);
                setRequirValues(prevValues => ({
                    ...prevValues,
                    ...response.data,
                    _id: response.data._id || id,
                    id: response.data._id || id,
                    regId: response.data.regId,
                    client: response.data.client,
                    typeOfContract: response.data.typeOfContract,
                    startDate: response.data.startDate,
                    duration: response.data.duration,
                    location: response.data.location,
                    sourceCtc: response.data.sourceCtc,
                    qualification: response.data.qualification,
                    yearsExperience: response.data.yearsExperience,
                    relevantExperience: response.data.relevantExperience,
                    skill: response.data.skill,
                    requirementtype: response.data.requirementtype,
                    priority: response.data.priority,
                    assessments: response.data.assessments,
                    update: response.data.update,
                    claimedBy: response.data.claimedBy,
                    jdPdf: response.data.jdPdf || '',
                    jdPdfOriginalName: response.data.jdPdfOriginalName || '',
                }));

                if (modalPayload?.workflow) {
                    setUploadAllowed(Boolean(modalPayload.workflow.canUpload));
                    setUploadBlockMessage(modalPayload.workflow.uploadDisabledMessage || getUploadDisabledMessage({ workflow: modalPayload.workflow }));
                } else if (response.data?.workflow) {
                    setUploadAllowed(Boolean(response.data.workflow.canUpload));
                    setUploadBlockMessage(response.data.workflow.uploadDisabledMessage || getUploadDisabledMessage(response.data));
                } else {
                    const enriched = await api.get(`/getrequirements/${id}`).then((res) => res.data);
                    const allowed = canUploadToRequirement(enriched);
                    setUploadAllowed(allowed);
                    setUploadBlockMessage(allowed ? '' : getUploadDisabledMessage(enriched));
                }
            } catch (err) {
                console.error('Error fetching requirement:', err);
            }
        };     
        const fetchUserData = async (email) => {
            try {
                const { data } = await api.get(`/loggedinuserdata/${email}`);
                setLoginUserData(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error('Error fetching user data:', err);
                setLoginUserData([]);
            }
        };
      
        fetchRequirement();
        fetchUserData(userEmail);
    }, [id, userId, userEmail, modalPayload?.workflow]);

    const assessmentCount = requirValues.assessments?.length || 0;
    const assessmentRequired = assessmentCount > 0;
    const canSubmitCandidate = !assessmentRequired || isAssessmentSubmitted;

    useEffect(() => {
        setScores(Array(assessmentCount).fill(''));
        setIsAssessmentSubmitted(!assessmentRequired);
    }, [assessmentCount, assessmentRequired, id]);

    // Check if all assessment score fields are filled
    useEffect(() => {
        if (!assessmentRequired) {
            setAllFieldsFilled(true);
            return;
        }
        setAllFieldsFilled(
            scores.length === assessmentCount
            && scores.every((score) => String(score).trim() !== '')
        );
    }, [scores, assessmentCount, assessmentRequired]);

    useEffect(() => {
        onSubmitReadyChange?.(!canSubmitCandidate || !uploadAllowed);
    }, [canSubmitCandidate, onSubmitReadyChange, uploadAllowed]);

    // Handle score change
  const handleScoreChange = (index, value) => {
    const updatedScores = [...scores];
    updatedScores[index] = value;
    setScores(updatedScores);
  };
    
    const assessmentsWithScores = requirValues.assessments.map((assessment, index) => ({
      assessment: assessment.assessment,
      yoe: assessment.yoe,
      score: scores[index] // Ensure scores[index] exists
  }));

const sendCandidateDataToDatabase = async (status) => {
  if (!uploadAllowed) {
    showWarning(uploadBlockMessage || getUploadDisabledMessage({}));
    return;
  }

  if (assessmentRequired && !isAssessmentSubmitted) {
    showError('Please fill all candidate ratings and click Submit Assessment before saving or uploading.');
    return;
  }

  const validation = validateCandidateUploadForm({
    firstName,
    lastName,
    mobileNumber,
    email,
    ctc,
    ectc,
    totalYoe,
    relevantYoe,
    lwd,
    currentLocation,
    prefLocation,
    resignationServed,
    currentOrg,
    candidateSkills,
    role,
    feedback,
    educationalQualification,
    offerInHand,
  });
  if (!validation.ok) {
    showError(validation.message);
    return;
  }

  const dobIso = toIsoDateString(dob);
  const lwdText = String(lwd || '').trim();
  const feedbackText = String(feedback || '').trim();

  if (status === 'Uploaded') {
    try {
      const duplicate = await checkCandidateDuplicate({
        email,
        mobileNumber,
        reqId: id,
      });
      if (duplicate.isDuplicate) {
        const matchName = duplicate.match?.candidateName ? ` (${duplicate.match.candidateName})` : '';
        const proceed = window.confirm(
          `${duplicate.message}${matchName}\n\nDo you still want to upload this candidate?`
        );
        if (!proceed) return;
      }
    } catch (error) {
      console.error('Duplicate check failed:', error);
    }
  }

  // Create a FormData object
  const formData = new FormData();

  // Append basic fields
  formData.append('reqId', id);
  formData.append('recruiterId', userId);

  // Create and append candidate data as a single JSON string
  const candidateData = {
      date: todayDate,
      firstName,
      lastName,
      ...(dobIso ? { dob: dobIso } : {}),
      mobileNumber,
      email,
      ctc,
      ectc,
      totalYoe,
      relevantYoe,
      lwd: lwdText,
      currentLocation,
      prefLocation,
      resignationServed,
      currentOrg,
      candidateSkills,
      role,
      savedStatus: status,
      feedback: feedbackText,
      details: details || '',
      interviewDate: toIsoDateString(interviewDate, '0000-00-00T00:00:00.000Z'),
      educationalQualification,
      offerInHand,
      remark: remark || '',
      assessments: assessmentsWithScores,
      recruiterId: userId,
      recruiterName:EmployeeName
  };
 
 
  
  formData.append('candidate', JSON.stringify(candidateData));

  // Append files if they exist
  if (updatedResumeRef.current?.files[0]) formData.append('updatedResume', updatedResumeRef.current.files[0]);
  if (ornnovaProfileRef.current?.files[0]) formData.append('ornnovaProfile', ornnovaProfileRef.current.files[0]);
  if (candidateimageRef.current?.files[0]) formData.append('candidateImage', candidateimageRef.current.files[0]);

  try {
      const { data: result } = await api.post('/Candidates', formData);

      console.log(result);
      if (embedded && onSuccess) onSuccess(status === 'Uploaded' ? 'Source profile uploaded successfully' : 'Source profile saved successfully');
      else {
        showSuccess(status === 'Uploaded' ? 'Source profile uploaded successfully ✓' : 'Source profile saved successfully ✓');
        setTimeout(() => window.location.reload(), 600);
      }

  } catch (error) {
      if (error.status === 409 && error.data?.status === 'Duplicate') {
        showError(error.message || 'Duplicate candidate submission blocked.');
        return;
      }
      console.error('Error:', error);
      showError(getApiErrorMessage(error, 'Failed to save candidate data. Please try again.'));
  }
};

useEffect(() => {
  if (loginUserData.length > 0) {
    setEmployeeName(loginUserData[0]?.EmployeeName); // assuming the first user's name

  }
}, [loginUserData]);

const submitAssessment = () => {
  if (!allFieldsFilled) {
    showError('Please fill all candidate ratings.');
    return;
  }
  setIsAssessmentSubmitted(true);
  showSuccess('Assessment submitted successfully ✓');
};

const openUploadForm = () => {
  if (!uploadAllowed) {
    showWarning(uploadBlockMessage || getUploadDisabledMessage({}));
    return;
  }
  setIsAssessmentSubmitted(!assessmentRequired);
  setScores(Array(assessmentCount).fill(''));
  setShow(true);
};
function handleUpdateShow() {
    
  setUpdateshow(true);
}
function handleUpdateClose () {setUpdateshow(false);}
const updateCandidate = async(id)=>{
  try {
    const response = await api.get(`/candidate/${id}`)
    console.log(response.data)
    setUpdateCandidateDetails({
      ...response.data,
      lwd: normalizeLwdForInput(response.data?.lwd),
    });
    handleUpdateShow();
  } catch (error) {
    console.log(error)
  }
}

const handleInputChange = (field, value) => {
  setUpdateCandidateDetails(prevDetails => ({
    ...prevDetails,
    [field]: value,
  }));
};

const handleAssessmentChange = (index, field, value) => {
  const updatedAssessments = [...updateCandidateDetails.assessments];
  updatedAssessments[index] = {
    ...updatedAssessments[index],
    [field]: value,
  };
  setUpdateCandidateDetails(prevDetails => ({
    ...prevDetails,
    assessments: updatedAssessments,
  }));
};

// Function that saves changes, with conditional logic for "Upload"
const handleSaveChanges = async (status) => {
const candidateId = updateCandidateDetails._id;

try {
  // Prepare updated details based on whether it's a save or upload action
  const updatedDetails = {
    ...updateCandidateDetails,
    lwd: String(updateCandidateDetails.lwd || '').trim(),
    ...(status === "Uploaded" ? { savedStatus: "Uploaded", uploadedDate: new Date().toISOString() } : {})
  };

  const response = await api.put(`/candidates/${candidateId}`, updatedDetails);

  if (response.status === 200) {
    showSuccess('Candidate details updated successfully ✓');
    setUpdateshow(false); // Close the modal after successful update
    window.location.reload();
  } else {
    showError('Failed to update candidate details. Please try again.');
  }
} catch (error) {
  console.error('Error updating candidate:', error);
  showError(getApiErrorMessage(error, 'An error occurred while updating candidate details.'));
}
};

const renderUploadFields = () => (
  <>
    <Row className="g-3">
      <Col md={6} lg={4}>
        <FormLabel><b>Date</b></FormLabel>
        <Form.Control type="date" style={{ borderRadius: "15px", border: "1px solid black", fontWeight: "bold" }} defaultValue={todayDate} readOnly />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Recruiter</b></FormLabel>
        {loginUserData.map((item, index) => (
          <Form.Control key={index} readOnly value={item.EmployeeName} style={{ borderRadius: "15px", border: "1px solid black", fontWeight: "bold" }} placeholder="Recruiter Name" />
        ))}
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Client</b></FormLabel>
        <Form.Control readOnly value={requirValues.client} style={{ borderRadius: "15px", border: "1px solid black", fontWeight: "bold" }} placeholder="Client" />
      </Col>
      <hr />
      <Col md={6} lg={4}>
        <FormLabel><b>First Name *</b></FormLabel>
        <Form.Control value={firstName} onChange={(e) => setFirstName(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="First Name" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Last Name *</b></FormLabel>
        <Form.Control value={lastName} onChange={(e) => setLastName(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="Last Name" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>DOB</b> <small className="text-muted">(Optional)</small></FormLabel>
        <Form.Control value={dob} onChange={(e) => setDob(e.target.value)} type="date" style={{ borderRadius: "15px", border: "1px solid black" }} />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Mobile Number *</b></FormLabel>
        <Form.Control value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="Mobile Number" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Email *</b></FormLabel>
        <Form.Control value={email} onChange={(e) => setEmail(e.target.value)} type="email" style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="Email" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>CTC in LPA *</b></FormLabel>
        <Form.Control value={ctc} onChange={(e) => setCtc(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="CTC in LPA" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>ECTC in LPA *</b></FormLabel>
        <Form.Control value={ectc} onChange={(e) => setEctc(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="ECTC in LPA" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Total YOE *</b></FormLabel>
        <Form.Control value={totalYoe} onChange={(e) => setTotalYoe(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="Total Years of Experience" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Relevant YOE *</b></FormLabel>
        <Form.Control value={relevantYoe} onChange={(e) => setRelevantYoe(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="Relevant Years of Experience" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>LWD *</b></FormLabel>
        <Form.Control value={lwd || ''} onChange={(e) => setLwd(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="LWD" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Current Location *</b></FormLabel>
        <Form.Control value={currentLocation} onChange={(e) => setCurrentLocation(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="Current Location" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Pref Location *</b></FormLabel>
        <Form.Control value={prefLocation} onChange={(e) => setPrefLocation(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="Pref Location" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Resignation Served *</b></FormLabel>
        <Form.Select value={resignationServed || ''} onChange={(e) => setResignationServed(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} required>
          <option value="">Choose...</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </Form.Select>
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Current Org *</b></FormLabel>
        <Form.Control value={currentOrg} onChange={(e) => setCurrentOrg(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="Current Org" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Source Profile Skills *</b></FormLabel>
        <Form.Control value={candidateSkills} onChange={(e) => setCandidateSkills(e.target.value)} as="textarea" rows={5} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="Source Profile Skills" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Role *</b></FormLabel>
        <Form.Control value={role} onChange={(e) => setRole(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="Role" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Recruiter Feedback *</b></FormLabel>
        <Form.Control value={feedback || ''} onChange={(e) => setFeedback(e.target.value)} as="textarea" rows={5} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="Recruiter Feedback" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>About Source Profile</b> <small className="text-muted">(Optional)</small></FormLabel>
        <Form.Control value={details} onChange={(e) => setDetails(e.target.value)} as="textarea" rows={5} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="About Source Profile" />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Interview Date</b> <small className="text-muted">(Optional)</small></FormLabel>
        <Form.Control value={interviewDate || ''} onChange={(e) => setInterviewDate(e.target.value)} type="date" style={{ borderRadius: "15px", border: "1px solid black" }} />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Educational Qualification *</b></FormLabel>
        <Form.Control value={educationalQualification} onChange={(e) => setEducationalQualification(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="Educational Qualification" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Offer in Hand *</b></FormLabel>
        <Form.Control value={offerInHand} onChange={(e) => setOfferInHand(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="Offer in Hand" required />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Remark</b> <small className="text-muted">(Optional)</small></FormLabel>
        <Form.Control value={remark} onChange={(e) => setRemark(e.target.value)} style={{ borderRadius: "15px", border: "1px solid black" }} placeholder="Remark" />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Updated Resume</b> <small className="text-muted">(Optional)</small></FormLabel>
        <Form.Control ref={updatedResumeRef} type="file" accept="application/pdf" style={{ borderRadius: "15px", border: "1px solid black" }} />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Ornnova Profile</b> <small className="text-muted">(Optional)</small></FormLabel>
        <Form.Control ref={ornnovaProfileRef} type="file" accept="application/pdf" style={{ borderRadius: "15px", border: "1px solid black" }} />
      </Col>
      <Col md={6} lg={4}>
        <FormLabel><b>Image</b> <small className="text-muted">(Optional)</small></FormLabel>
        <Form.Control ref={candidateimageRef} type="file" style={{ borderRadius: "15px", border: "1px solid black" }} />
      </Col>
    </Row>

    {assessmentRequired && (
      <>
        <hr />
        <h5 className="text-center mb-3">
          <img style={{ width: "28px", marginRight: "8px" }} src="/Images/icon.png" alt="icon" />
          <b style={{ fontFamily: "monospace" }}>Assessment</b>
        </h5>
        <Table bordered hover responsive className="hr-table mb-3">
          <thead>
            <tr>
              <th>Assessment</th>
              <th>Expected Rating</th>
              <th>Candidate Rating</th>
            </tr>
          </thead>
          <tbody>
            {requirValues.assessments.map((assessment, index) => (
              <tr key={index}>
                <td style={{ textAlign: "left" }}>{assessment.assessment}</td>
                <td>{assessment.yoe}</td>
                <td>
                  <Form.Control
                    value={scores[index] || ''}
                    onChange={(e) => handleScoreChange(index, e.target.value)}
                    placeholder="Enter candidate rating"
                    style={{ textAlign: "center", borderRadius: "10px", border: "1px solid black" }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="text-center mb-3">
          <Button
            onClick={() => submitAssessment()}
            disabled={!allFieldsFilled}
            style={{
              minWidth: "200px",
              borderRadius: "20px",
              backgroundColor: isAssessmentSubmitted ? "mediumseagreen" : (hover ? "green" : "gray"),
              color: "white",
              border: "1.5px solid lightgray",
              fontWeight: "bold",
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            {isAssessmentSubmitted ? "Assessment Submitted" : "Submit Assessment"}
          </Button>
        </div>
      </>
    )}

    {!assessmentRequired && (
      <p className="text-muted mt-2 mb-0">
        <small>No assessments configured for this requirement.</small>
      </p>
    )}

    {assessmentRequired && !isAssessmentSubmitted && (
      <p className="text-danger mt-2 mb-0 text-center">
        <small>Fill all candidate ratings and click Submit Assessment before Save or Upload.</small>
      </p>
    )}
    <hr />
    {!embedded && (
      <center>
        <Button
          onClick={() => { setSavedStatus("Saved"); sendCandidateDataToDatabase("Saved"); }}
          disabled={!canSubmitCandidate}
          style={{ borderRadius: "10px", margin: "20px", width: "100px", backgroundColor: canSubmitCandidate ? "slateblue" : "lightgray", border: "0px", fontWeight: "bolder" }}
          title={canSubmitCandidate ? "This Will Only Save the Details, will Not be Uploaded" : "Complete Take Assessment first"}
        >
          Save
        </Button>
        <Button
          onClick={() => { setSavedStatus("Uploaded"); sendCandidateDataToDatabase("Uploaded"); }}
          disabled={!canSubmitCandidate}
          style={{ borderRadius: "10px", margin: "20px", width: "100px", backgroundColor: canSubmitCandidate ? "green" : "lightgray", border: "0px", fontWeight: "bolder" }}
          title={canSubmitCandidate ? "Upload source profile" : "Complete Take Assessment first"}
        >
          Upload
        </Button>
      </center>
    )}
  </>
);

// Separate functions for Save and Upload buttons
const saveChanges = () => handleSaveChanges("Saved");
const uploadChanges = () => handleSaveChanges("Uploaded");

const handleUploadSubmit = (e) => {
  e.preventDefault();
  setSavedStatus('Uploaded');
  sendCandidateDataToDatabase('Uploaded');
};

if (embedded) {
  return (
    <div className="hr-embedded-form">
      {!uploadAllowed && (
        <div className="alert alert-warning py-2">
          {uploadBlockMessage || getUploadDisabledMessage({})}
        </div>
      )}
      <Row className="mb-2 g-2">
        <Col xs={6} md={4}><small><strong>Reg ID:</strong> {requirValues.regId || '—'}</small></Col>
        <Col xs={6} md={4}><small><strong>Client:</strong> {requirValues.client || '—'}</small></Col>
      </Row>
      <div className="mb-3">
        <small><strong>Job Description:</strong></small>
        <div className="mt-1">
          <RequirementJdActions requirement={requirValues} />
        </div>
      </div>
      <Form
        id="upload-candidate-form"
        onSubmit={handleUploadSubmit}
      >
        {renderUploadFields()}
      </Form>
    </div>
  );
}

    return (
        <div>
            <center> <hr></hr>
           <center>
           <h3 style={{ textAlign: "center", }}>
                <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon" />
                <b style={{ fontFamily: "monospace" }}>Requirement Details</b>
            </h3>
           </center>

            {/* Requirement and Assessment Table */}
            <Table style={{textAlign:"center"}} bordered hover responsive>
                <thead>
                    <tr>
                        <th>Reg Id</th>
                        <th>Requirement Type</th>
                        <th>Priority</th>
                        <th>Client</th>
                        <th>Type Of Contract</th>
                        <th>Start Date</th>
                        <th>Duration</th>
                        <th>Number of Positions</th>
                        <th>Source Ctc</th>
                        <th>Location</th>
                        <th>Qualification</th>
                        <th>Years of Experience</th>
                        <th>Relevant Experience</th>
                        <th>Skills</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{requirValues.regId}</td>
                        <td>{normalizeRequirementType(requirValues.requirementtype)}</td>
                        <td><PriorityBadge priority={requirValues.priority} /></td>
                        <td>{requirValues.client}</td>
                        <td>{requirValues.typeOfContract}</td>
                        <td>{new Date(requirValues.startDate).toLocaleDateString()}</td>
                        <td>{requirValues.duration}</td>
                        <td>{requirValues.numberOfPositions ?? 1}</td>
                        <td>{requirValues.sourceCtc}</td>
                        <td>{requirValues.location}</td>
                        <td>{requirValues.qualification}</td>
                        <td>{requirValues.yearsExperience}</td>
                        <td>{requirValues.relevantExperience}</td>
                        <td>{requirValues.skill}</td>
                    </tr>
                </tbody>
            </Table> <hr></hr>

            {!uploadAllowed && (
              <div className="alert alert-warning py-2 mx-auto" style={{ maxWidth: '720px' }}>
                {uploadBlockMessage || getUploadDisabledMessage({})}
              </div>
            )}

            <div className="mb-3 text-center">
              <h5>
                <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon" />
                <b style={{ fontFamily: "monospace" }}>Job Description</b>
              </h5>
              <RequirementJdActions requirement={requirValues} className="justify-content-center" />
            </div>
            <hr></hr>

            {/* Assessment Details */}
            <h3 style={{ textAlign: "center", }}>
                <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon" />
                <b style={{ fontFamily: "monospace" }}>Assessment </b>
            </h3>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>Assessment</th>
                        <th>Expected Rating</th>
                    </tr>
                </thead>
                <tbody>
                    {requirValues.assessments.map((assessment, index) => (
                        <tr key={index}>
                            <td>{assessment.assessment}</td>
                            <td>{assessment.yoe}</td>
                        </tr>
                    ))}
                </tbody>
            </Table> <hr></hr>

            {/* Candidates Uploaded Table */}
            <h3 style={{ textAlign: "center", }}>
                <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon" />
                <b style={{ fontFamily: "monospace" }}>Source Profiles Uploaded </b>
            </h3>
            <Table style={{textAlign:"center"}} bordered hover responsive>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>ECTC</th>
                        <th>Status</th>
                        <th>Uploaded On</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {candidateData && candidateData.length > 0 ? (
                        candidateData.map((item, index) => {
                            const recentStatus = getPersistedCandidateStatus(item);

                            return (
                                <tr key={index}>
                                    <td>{item.firstName} {item.lastName}</td>
                                    <td>{item.ectc}</td>
                                    <td>
                                        <StatusBadge status={recentStatus} useStoredLabel />
                                    </td>
                                    <td>{item.uploadedOn ? new Date(item.uploadedOn).toLocaleDateString() : "N/A"}</td>
                                    <td>
                                    {item.savedStatus === 'Saved' ? (
    <Button
        onClick={() => updateCandidate(item._id)}
        style={{ fontWeight: "bold", backgroundColor: "green", border: "0px", padding: "5px", borderRadius: "20px" }}
        onMouseMove={(e) => { e.target.style.backgroundColor = "gray"; e.target.style.padding = "7px"; }}
        onMouseLeave={(e) => { e.target.style.backgroundColor = "green"; e.target.style.padding = "5px"; }}
    >
        Upload
    </Button>
) : recentStatus === 'No Action Taken' ? (
    <Button
        onClick={() => updateCandidate(item._id)}
        style={{ fontWeight: "bold", backgroundColor: "lightgreen", color: "black", border: "0px", padding: "5px 12px", borderRadius: "20px" }}
        onMouseMove={(e) => { e.target.style.backgroundColor = "gray"; e.target.style.color = "white"; }}
        onMouseLeave={(e) => { e.target.style.backgroundColor = "lightgreen"; e.target.style.color = "black"; }}
    >
        Edit
    </Button>
) : (
    <span>--</span>
)}

                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4">No data available</td>
                        </tr>
                    )}
                </tbody>
            </Table> <hr></hr>
                    <Row>
                        <center>
                        <Button
                          disabled={!uploadAllowed}
                          title={!uploadAllowed ? (uploadBlockMessage || getUploadDisabledMessage({})) : ''}
                          onMouseMove={(e)=> { if (uploadAllowed) { e.target.style.backgroundColor="gray"; e.target.style.color="white"; } }}
                          onMouseLeave={(e)=> { if (uploadAllowed) { e.target.style.backgroundColor="lightsteelblue"; e.target.style.color="black"; } }}
                          style={{
                            borderRadius:"20px",
                            fontWeight:"bold",
                            border:"0px",
                            backgroundColor: uploadAllowed ? "lightsteelblue" : "lightgray",
                            color: uploadAllowed ? "black" : "darkgray",
                            cursor: uploadAllowed ? "pointer" : "not-allowed",
                          }}
                          onClick={openUploadForm}
                        >
                       Upload Source Profile
                       </Button>

      <Modal
      show={show}
      onHide={() => setShow(false)}
      fullscreen={true}
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          <h3 style={{ textAlign: "center", fontFamily: "initial" }}>
            <b><img style={{ width: "35px", borderRadius: "50px" }} src='/Images/icon.png' alt="logo"/> Upload Source Profile</b>
          </h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          id="upload-candidate-form"
          onSubmit={handleUploadSubmit}
          style={{ backgroundColor: "aliceblue", padding: "30px", borderRadius: "20px" }}
        >
          {renderUploadFields()}
        </Form>
      </Modal.Body>
    </Modal>
                        </center>
                    </Row>
                  
              
            </center>
            {/* Additional form code for uploading candidate details (commented out) */}

            <Modal
      style={{ backgroundColor: "lightgray", opacity: "98%" }}
      show={updateshow}
      size="lg"
      onHide={handleUpdateClose}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          <h5>
            <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon"></img>
            <b style={{ fontFamily: "monospace" }}>Update Source Profile Information</b>
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <form style={{backgroundColor:"lightsteelblue",borderRadius:"20px"}}>
            <div className="container">
                <div className="row">
                    <div className="col-md-6 form-group">
                        <label><strong>Candidate Image:</strong></label>
                        <div>
                            <img
                                src={`${API_BASE_URL}/${updateCandidateDetails.candidateImage}`}
                                style={{ width: "100px", borderRadius: "100px" }}
                                alt=""
                            />
                        </div>
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>First Name:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.firstName}
                            onChange={(e) => handleInputChange('firstName', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Last Name:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.lastName}
                            onChange={(e) => handleInputChange('lastName', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Email:</strong></label>
                        <input
                            type="email"
                            className="form-control"
                            value={updateCandidateDetails.email}
                            onChange={(e) => handleInputChange('email', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Mobile Number:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.mobileNumber}
                            onChange={(e) => handleInputChange('mobileNumber', e.target.value)}
                        />
                    </div>
                   
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Date of Birth:</strong></label>
                        <input
                            type="date"
                            className="form-control"
                            value={toDateInputValue(updateCandidateDetails.dob)}
                            onChange={(e) => handleInputChange('dob', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>CTC:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.ctc}
                            onChange={(e) => handleInputChange('ctc', e.target.value)}
                        />
                    </div>
                   
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>ECTC:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.ectc}
                            onChange={(e) => handleInputChange('ectc', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Total YOE:</strong></label>
                        <input
                            type="number"
                            className="form-control"
                            value={updateCandidateDetails.totalYoe}
                            onChange={(e) => handleInputChange('totalYoe', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Relevant YOE:</strong></label>
                        <input
                            type="number"
                            className="form-control"
                            value={updateCandidateDetails.relevantYoe}
                            onChange={(e) => handleInputChange('relevantYoe', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>LWD:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.lwd ?? ''}
                            onChange={(e) => handleInputChange('lwd', e.target.value)}
                            placeholder="LWD"
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Current Location:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.currentLocation}
                            onChange={(e) => handleInputChange('currentLocation', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Preferred Location:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.prefLocation}
                            onChange={(e) => handleInputChange('prefLocation', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Resignation Served:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.resignationServed}
                            onChange={(e) => handleInputChange('resignationServed', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Current Organization:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.currentOrg}
                            onChange={(e) => handleInputChange('currentOrg', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Candidate Skills:</strong></label>
                        <textarea
                            className="form-control"
                            value={updateCandidateDetails.candidateSkills}
                            onChange={(e) => handleInputChange('candidateSkills', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Role:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.role}
                            onChange={(e) => handleInputChange('role', e.target.value)}
                        />
                    </div>
                   
                </div>
                {/* <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Internal Screening:</strong></label>
                        <select
                            className="form-control"
                            value={updateCandidateDetails.internalScreening}
                            onChange={(e) => handleInputChange('internalScreening', e.target.value)}
                        >
                            <option value="Selected">Selected</option>
                            <option value="Rejected">Rejected</option>
                        </select>
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Shared With Client:</strong></label>
                        <select
                            className="form-control"
                            value={updateCandidateDetails.sharedWithClient}
                            onChange={(e) => handleInputChange('sharedWithClient', e.target.value)}
                        >
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                   
                </div> */}
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Recruiter Feedback:</strong></label>
                        <textarea
                            className="form-control"
                            value={updateCandidateDetails.feedback}
                            onChange={(e) => handleInputChange('feedback', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>About Candidate:</strong></label>
                        <textarea
                            className="form-control"
                            value={updateCandidateDetails.details}
                            onChange={(e) => handleInputChange('details', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Interview Date:</strong></label>
                        <input
                            type="date"
                            className="form-control"
                            value={new Date(updateCandidateDetails.interviewDate).toLocaleDateString('en-CA')}
                            onChange={(e) => handleInputChange('interviewDate', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Educational Qualification:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.educationalQualification}
                            onChange={(e) => handleInputChange('educationalQualification', e.target.value)}
                        />
                    </div>
                    
                </div>
                <div className="row">
                <div className="col-md-6 form-group">
                        <label><strong>Offer In Hand:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={updateCandidateDetails.offerInHand}
                            onChange={(e) => handleInputChange('offerInHand', e.target.value)}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <label><strong>Last Interview Date:</strong></label>
                        <input
                            type="date"
                            className="form-control"
                            value={new Date(updateCandidateDetails.interviewDate).toLocaleDateString('en-CA')}
                            onChange={(e) => handleInputChange('lastInterviewDate', e.target.value)}
                        />
                    </div>
                </div> <hr></hr>
                <div className="row">
            <div className="col-md-12 form-group">
                <h3>
                    <img style={{width: "30px", margin: "10px"}} src='/Images/icon.png' alt="icon" />
                    <b style={{fontFamily: "monospace"}}>Assessment Details</b>
                </h3>
                {updateCandidateDetails.assessments.map((assessment, index) => (
                    <div key={index} className="form-group">
                        <label><strong>Assessment {index + 1}:</strong></label>
                        <input
                            readOnly
                            type="text"
                            className="form-control"
                            value={assessment.assessment}
                        />
                        <label><strong>Expected Rating:</strong></label>
                        <input
                            readOnly
                            type="text"
                            className="form-control"
                            value={assessment.yoe}
                        />
                        <label><strong>Candidate Rating:</strong></label>
                        <input
                            type="text"
                            className="form-control"
                            value={assessment.score}
                            onChange={(e) => handleAssessmentChange(index, 'score', e.target.value)}
                        />
                        <hr />
                    </div>
                ))}
            </div>
        </div>
            </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
      {updateCandidateDetails.savedStatus === "Saved" && (
                    <Button style={{borderRadius:"20px",backgroundColor:"mediumseagreen",color:"white",border:"1.5px solid black",fontWeight:"bold"}}
                        type="button"
                        className="btn btn-secondary ml-2"
                        onMouseMove={(e)=> { e.target.style.backgroundColor = "lightgray";e.target.style.color = "black";e.target.style.padding = "10px"; }}
                        onMouseLeave={(e)=> { e.target.style.backgroundColor = "mediumseagreen";e.target.style.color = "white";e.target.style.padding = "7px"; }}
                        onClick={uploadChanges}
                        // onClick={handleUploadStatus}
                    >
                        Upload
                    </Button>
                )}
        <Button                         onMouseMove={(e)=> { e.target.style.backgroundColor = "green";e.target.style.color = "white";e.target.style.padding = "10px"; }}
                        onMouseLeave={(e)=> { e.target.style.backgroundColor = "lightgray";e.target.style.color = "green";e.target.style.padding = "7px"; }}
 style={{borderRadius:"20px",backgroundColor:"lightgray",color:"green",border:"1.5px solid black",fontWeight:"bold"}} onClick={saveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
        </div>
    );
}

export default UserActions;



